<template>
  <div class="tasting-notes-region">
    <HighlightButton
      v-for="(file, index) in notes"
      :key="index"
      :url="previousTastingNotesFiles[index]"
      :url-new-window="true"
      :title="title(file)"
      button-type="rounded"
      button-style="outline"
      icon="tail-arrow-down"
      block
    />
  </div>
</template>
<script>

export default {
  name: 'tasting-notes',
  props: {
    notes: {
      type: [Array],
      required: false,
      default: () => { return {} }
    }
  },
  data: () => {
    return {
      previousTastingNotesFiles: []
    }
  },
  mounted() {
    if (this.notes) {
      this.getPreviousTastingNotesFiles()
    }
  },
  methods: {
    title(file) {
      if (file && file.file && file.file.data && file.file.data.title) return file.file.data.title
      return 'Download Tasting Notes'
    },
    getPreviousTastingNotesFiles() {
      for (const [index, { file }] of this.notes.entries()) {
        this.$store.dispatch('filestore/getFileURL', file)
          .then(href => {
            this.$set(this.previousTastingNotesFiles, index, href)
          })
      }
    }
  }
}
</script>
